'use client'

import ErrorPage from '@/components/common/error-page'
import { reportBrowserError } from '@/lib/observability/new-relic-browser'
import { useTopLoader } from 'nextjs-toploader'
import { useEffect } from 'react'

export default function ErrorHandler({ error }) {
  const { done } = useTopLoader()
  useEffect(() => {
    done()
  }, [done])

  useEffect(() => {
    reportBrowserError(error, { 'error.boundary': 'app' })
  }, [error])

  return <ErrorPage error={error} />
}
